import { render, staticRenderFns } from "./ksa_skyexpress.vue?vue&type=template&id=7cb30ebb&"
import script from "./ksa_skyexpress.vue?vue&type=script&lang=js&"
export * from "./ksa_skyexpress.vue?vue&type=script&lang=js&"
import style0 from "./ksa_skyexpress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports